// extracted by mini-css-extract-plugin
var _1 = "AuthLicense-moduleAuthLicense__m52dv";
export { _1 as "AuthLicense" }
